/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Rest_Live_ChannelInputs */

const en_us2_native_release_rest_live_channel = /** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest in progress`)
};

const pt_br2_native_release_rest_live_channel = /** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso em andamento`)
};

const pt_pt2_native_release_rest_live_channel = /** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso em andamento`)
};

/** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */
const es_419_native_release_rest_live_channel = en_us2_native_release_rest_live_channel;

/** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */
const fr_fr2_native_release_rest_live_channel = en_us2_native_release_rest_live_channel;

/** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */
const de_de2_native_release_rest_live_channel = en_us2_native_release_rest_live_channel;

/** @type {(inputs: Native_Release_Rest_Live_ChannelInputs) => LocalizedString} */
const it_it2_native_release_rest_live_channel = en_us2_native_release_rest_live_channel;

/**
* | output |
* | --- |
* | "Rest in progress" |
*
* @param {Native_Release_Rest_Live_ChannelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_rest_live_channel = /** @type {((inputs?: Native_Release_Rest_Live_ChannelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Rest_Live_ChannelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_rest_live_channel(inputs)
	if (locale === "es-419") return es_419_native_release_rest_live_channel(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_rest_live_channel(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_rest_live_channel(inputs)
	if (locale === "de-DE") return de_de2_native_release_rest_live_channel(inputs)
	if (locale === "it-IT") return it_it2_native_release_rest_live_channel(inputs)
	return en_us2_native_release_rest_live_channel(inputs)
});
export { native_release_rest_live_channel as "native-release.rest_live_channel" }